import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=3436759c&scoped=true&"
import script from "./MessageForm.vue?vue&type=script&lang=ts&"
export * from "./MessageForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436759c",
  null
  
)

export default component.exports